/** `?mode=live|test` selects the products tab on first paint (AC-013, ACTION_ROUTING A6). Read once; the tab state owns it afterwards. */
export type PaywallProductsMode = 'test' | 'live';
export const MODE_QUERY_PARAM = 'mode';

export function parseProductsModeParam(search: string): PaywallProductsMode | null {
  const value = new URLSearchParams(search).get(MODE_QUERY_PARAM);
  return value === 'live' || value === 'test' ? value : null;
}
